const LOCAL_STORAGE_KEY = 'br.com.softplan.ungp.portal.solicitacoes';

export const getIdentificationUserStorage = () => {
	if (hasIndentificationUser()) {
		return JSON.parse(localStorage[LOCAL_STORAGE_KEY]).usuario.identificacao;
	}
	return null;
};

export const getIdentificationUserStorageWithMask = () => {
	if (hasIndentificationUser()) {
		return JSON.parse(localStorage[LOCAL_STORAGE_KEY])
			.usuario.identificacao.match(/\d+/g)
			.join([]);
	}
	return null;
};

export const hasIndentificationUser = () => {
	return (
		localStorage[LOCAL_STORAGE_KEY] &&
		JSON.parse(localStorage[LOCAL_STORAGE_KEY]).usuario &&
		JSON.parse(localStorage[LOCAL_STORAGE_KEY]).usuario.identificacao
	);
};
